(function ($) {

    $(document).ready(function () {

        if ($('.featured-videos-vue').length) {

            function viewSliderInit (target, params) {
                new Vue({
                    el: target,
                    data: {
                        slides: 0
                    },
                    created() {
                        setTimeout(function () {
                            setActiveDot(0);
                        }, 500);

                    },
                    methods: {
                        onBeforeSlideChange(index) {
                            setActiveDot(index);
                            iframeRefresh();
                        },
                        onAfterSlideChange(index) {
                            //iframeRefresh(index);
                        },
                        goToSlide(index) {
                            this.$refs.mycarousel.goSlide(index);
                        }
                    },
                    components: {
                        'carousel-3d': Carousel3d.Carousel3d,
                        'slide': Carousel3d.Slide
                    },

                    mounted: function () {
                        let self = this;

                        self.slides = params;

                    }
                });
            }
            const section = $('.featured-videos-vue');
            console.log($('.featured-videos-vue').length);
            let counter = 0;
            section.each(function () {
                counter++;
                $(this).find('.js-featured-videos-vue-slider').addClass(`js-featured-videos-${counter}`);
                const data = $(`.js-featured-videos-${counter}`).data('params');
                viewSliderInit(`.js-featured-videos-${counter}`, data);
            });

            function iframeRefresh() {
                $('#featured-videos-vue-slider .carousel-3d-slide').each(function () {

                    var iframe = $(this).find('iframe');
                    iframe[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
                    $('#featured-videos-vue-slider .carousel-3d-slide.current iframe').focus();
                });
            }

            function setActiveDot(index) {
                $('#featured-videos-vue-slider .dots li').removeClass('active');
                $('#featured-videos-vue-slider .dots li[index=' + index + ']').addClass('active');
            }
        }

    });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/featured-videos-vue.es6